import { userReviews } from '@/mocks/reviews';

export default function Reviews() {
  return (
    <section className="w-full py-14 md:py-20 bg-accent-50/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold text-primary-600 tracking-wide">漫友评价</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            听听他们怎么说
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            来自真实用户的使用体验，是我们不断前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {userReviews.map((review) => (
            <div key={review.id} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-2">
                {review.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                {review.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}